/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Col, Row, Spin } from 'antd';
import { Select, Tag } from '..';

const { Option } = Select;
const Index = (props) => {
  const {
    options = [],
    placeholder,
    onChangeFilterSearch,
    showSearch,
    loading,
    selected = [],
    setSelected,
    type,
    onSelect,
  } = props;
  const onGetSelected = selected?.filter((item) => {
    return item?.targeting_type === type;
  });
  return (
    <Row gutter={[12, 12]}>
      <Col span={24}>
        <Select
          mode="multiple"
          value={(() => {
            return onGetSelected.map((item) => {
              return item?.targeting_value;
            });
          })()}
          onSelect={(value, values) => {
            setSelected((prev) => {
              if (onSelect) {
                onSelect([...prev, values]);
              }
              return [...prev, values];
            });
          }}
          onSearch={(value) => {
            if (onChangeFilterSearch) {
              onChangeFilterSearch(value);
            }
          }}
          placeholder={placeholder}
          className="hide-tag"
          maxTagCount={0}
          listHeight={240}
          showSearch={showSearch}
          filterOption={false}
          notFoundContent={loading ? <Spin /> : 'Not found'}
          onBlur={() => {
            if (onChangeFilterSearch) {
              onChangeFilterSearch('');
            }
          }}
          loading={loading}
        >
          {options.map((item) => {
            return (
              <Option
                {...item}
                key={item?.targeting_value}
                value={item?.targeting_value}
                label={item?.label}
              >
                {item?.label}
              </Option>
            );
          })}
        </Select>
      </Col>
      {onGetSelected?.length !== 0 && (
        <Col span={24}>
          <Row gutter={[12, 12]}>
            {onGetSelected?.map((item) => {
              return (
                <Tag
                  key={item?.key}
                  borderRadius="12px"
                  padding="14px 16px"
                  fontSize="16px"
                  fontWeight={600}
                  closable
                  onClose={() => {
                    setSelected((prev) => {
                      return prev.filter((data) => {
                        const filtered =
                          data?.targeting_value === item?.targeting_value &&
                          data?.targeting_type === type;
                        if (filtered) return false;
                        return true;
                      });
                    });
                  }}
                >
                  {item?.label || item?.name}
                </Tag>
              );
            })}
          </Row>
        </Col>
      )}
    </Row>
  );
};

export default Index;
